<div *ngIf="showModal">
  <aura-modal
    [title]="content.tracker.educationalTitle"
    [bodyTemplate]="auraModalBody"
    (opened)="opened($event)"
    (dismiss)="dismissModal()"
  ></aura-modal>
  <ng-template #auraModalBody>
    <idp-educational-content
      (viewBenefitsAction)="viewBenefitsAction.emit($event)"
    ></idp-educational-content>
  </ng-template>
</div>
<div class="skymiles__wrapper__right__container">
  <div class="skymiles__wrapper__right__container--top">
    <idp-onboarding
      *ngIf="!content.onboarding.disabled"
      [content]="content.onboarding"
    ></idp-onboarding>
    <idp-micro-moments
      [content]="content.microMoments"
      [skeletonMetaData]="{
        loaded: content.microMoments.loaded,
        error: content.microMoments.error,
        disabled: content.microMoments.disabled
      }"
      (action)="redirect($event)"
      (microMomentClick)="bannerClickEvent.emit($event)"
      auraSkeletonLoader
    ></idp-micro-moments>
    <label class="skymiles__wrapper__overview__title">
      {{ content.header }}
    </label>
    <div class="skymiles__wrapper__overview__container">
      <div class="skymiles__wrapper__overview__container__left">
        <div
          [shape]="{
            verticalRectangle: {
              display: true,
              count: 1
            }
          }"
          [skeletonMetaData]="{
            loaded: content.tracker.loaded,
            error: getFullError(content.tracker.error),
            disabled: content.tracker.disabled
          }"
          (action)="redirect($event)"
          auraSkeletonLoader
          class="skymiles__wrapper__overview__container__wrap"
        >
          <aura-tracker
            *ngIf="content.tracker.earnometer"
            [content]="content.tracker"
            (action)="onTrackerAction()"
          ></aura-tracker>
        </div>
      </div>
      <div class="skymiles__wrapper__overview__container__right">
        <div class="skymiles__wrapper__overview__container__wrap">
          <idp-overview-summary
            *ngIf="!content.summary.disabled"
            [content]="content.summary"
            (analyticsEvent)="onAnalyticsEvent($event)"
          ></idp-overview-summary>
        </div>
        <div class="skymiles__wrapper__overview__container__wrap">
          <idp-overview-summary
            [content]="content.status"
            [shape]="{
              verticalRectangle: {
                display: true,
                count: 1
              }
            }"
            [skeletonMetaData]="{
              loaded: content.status.loaded,
              error: getFullError(content.status.error),
              disabled: content.status.disabled
            }"
            (action)="redirect($event)"
            (analyticsEvent)="onAnalyticsEvent($event)"
            auraSkeletonLoader
          ></idp-overview-summary>
        </div>
        <idp-card-carousel
          *ngIf="!content.cards?.disabled"
          [content]="content.cards"
        ></idp-card-carousel>
      </div>
    </div>
  </div>
  <div class="skymiles__wrapper__right__container--bottom">
    <idp-earns-summary
      [content]="content.earnsSummary"
      [skeletonMetaData]="{
        loaded: content.earnsSummary.loaded,
        error: content.earnsSummary.error,
        disabled: content.earnsSummary.disabled
      }"
      (action)="redirect($event)"
      (analyticsEvent)="onAnalyticsEvent($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-earns-summary>

    <!--New Design-->
    <idp-skyclub-spend-tracker
      [content]="content.amexSkyClubTracker"
      [skeletonMetaData]="{
        loaded: content.amexSkyClubTracker.loaded,
        error: content.amexSkyClubTracker.error,
        disabled: content.amexSkyClubTracker.disabled
      }"
      (skyclubTrackerClick)="bannerClickEvent.emit($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-skyclub-spend-tracker>
    <!--New Design-->

    <idp-sky-club-tracker
      [content]="content.skyclubTracker"
      [skeletonMetaData]="{
        loaded: content.skyclubTracker.loaded,
        error: content.skyclubTracker.error,
        disabled: content.skyclubTracker.disabled
      }"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-sky-club-tracker>
    <idp-quick-links
      [content]="content.quickLinks"
      [skeletonMetaData]="{
        loaded: content.quickLinks.loaded,
        error: content.quickLinks.error,
        disabled: content.quickLinks.disabled
      }"
      (action)="redirect($event)"
      (clickAnalyticsEvent)="clickAnalyticsEvent.emit($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-quick-links>
    <idp-benefits
      [content]="content.benefits"
      [skeletonMetaData]="{
        loaded: content.benefits.loaded,
        error: content.benefits.error,
        disabled: content.benefits.disabled
      }"
      (action)="redirect($event)"
      (clickAnalyticsEvent)="clickAnalyticsEvent.emit($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      id="benefits"
      auraSkeletonLoader
    ></idp-benefits>
    <idp-snapshot
      [content]="content.snapshot"
      [skeletonMetaData]="{
        loaded: content.snapshot.loaded,
        error: content.snapshot.error,
        disabled: content.snapshot.disabled
      }"
      (action)="redirect($event)"
      (analyticsEvent)="onAnalyticsEvent($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-snapshot>

    <idp-upgrades
      [content]="content.upgrades"
      [skeletonMetaData]="{
        loaded: content.upgrades.loaded,
        error: content.upgrades.error,
        disabled: content.upgrades.disabled
      }"
      (action)="redirect($event)"
      (upgradeCardClick)="bannerClickEvent.emit($event)"
      class="skymiles__wrapper__right__container--bottom-gap"
      auraSkeletonLoader
    ></idp-upgrades>
    <idp-earns
      (openLink)="redirect($event)"
      (fastActionBannerClick)="bannerClickEvent.emit($event)"
      [content]="content.earns"
      class="skymiles__wrapper__right__container--bottom-gap"
      (clickAnalyticsEvent)="clickAnalyticsEvent.emit($event)"
      (analyticsEvent)="onAnalyticsEvent($event)"
    ></idp-earns>
    <div
      *ngIf="!content.stipulation.disabled"
      class="skymiles__wrapper__footer"
    >
      <idp-stipulation [content]="content.stipulation"></idp-stipulation>
    </div>
  </div>
</div>
